import { actionTypes } from '../../../types';

const initialState = {
    loading: false,
    data: null,
    error: null,
    status: null,
    message: null,
};

const uploadProfilePhotoReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPLOAD_PROFILE_PHOTO_REQUEST:
            return { ...state, loading: true, error: null };
        case actionTypes.UPLOAD_PROFILE_PHOTO_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.response,
                status: action.payload.status,
                message: action.payload.message,
                error: null,
            };
        case actionTypes.UPLOAD_PROFILE_PHOTO_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.message,
                status: action.payload.status,
                message: action.payload.message,
            };
        case actionTypes.UPLOAD_PROFILE_PHOTO_RESET:
            return { ...state, status: null, message: null };
        case actionTypes.UPLOAD_PROFILE_PHOTO_RESET_ALL:
            return initialState;
        default:
            return state;
    }
};

export default uploadProfilePhotoReducer;
